import { FC, useEffect } from 'react';

import { localizationSelector } from 'store/localizationState';
import { useTranslations } from 'hooks/useTranslations';
import { useAppSelector } from 'hooks/redux';
import favicon from 'assets/images/favicon_husqvarna.ico';
import { isConstruction } from 'config';

type Props = {
  title: string;
};

const SeoHelmet: FC<Props> = ({ title }) => {
  const t = useTranslations();
  const { languageCode } = useAppSelector(localizationSelector);

  const pageTitle = `${t(isConstruction ? 'start.construction.header' : 'start.husqvarna.header')} - ${t(title)}`;

  // Set attribute lang to html element
  useEffect(() => {
    document.documentElement.lang = languageCode;
  }, [languageCode]);

  return (
    <>
      <title>{pageTitle}</title>
      <link rel="icon" href={favicon} />
    </>
  );
};

export default SeoHelmet;
